const DUAL_INVEST = 'https://invest.antimatter.finance/#/'
const DEFI_OPTION_VAULT = 'https://dov.antimatter.finance/#/'

export const DUAL_INVESTMENT_LINK = DUAL_INVEST + 'dual-invest'
export const RECURRING_STRATEGY_LINK = DUAL_INVEST + 'recurring-vault'
export const DUAL_INVEST_PRODUCT_LINK = DUAL_INVEST + 'dual-invest-mgmt/:productId'

export const DEFI_OPTION_VAULT_LINK = DEFI_OPTION_VAULT + 'defi'
export const DEFI_OPTION_MGMT_LINK = DEFI_OPTION_VAULT + 'defi-vault-mgmt/:chainName/:currency/:type'
